import React, { useEffect, useRef } from "react";
import { SDrawerOrModal, SLowcodeList, STags } from "shj-components";
import { useAtom } from "jotai";

import { SPUDataAtom } from "@/pages/combinationManage/components/store.js";
import { config } from './config.jsx'
import { useSetState } from "ahooks";
import { message } from "antd";
import { getProductSkuSelectList } from "@/services/product.ts";

const ChooseSKUModal = (props) => {
  const { open, onClose, changeDataSource = true, spuData = {} } = props;
  const listRef = useRef();
  const [SPUData, setSPUData] = useAtom(SPUDataAtom)
  const [state, setState] = useSetState({
    selectedRowKeys: [],
    selectedRows: [],
  })

  useEffect(() => {
    if (open){
      if(changeDataSource){
        setState({ selectedRowKeys: spuData.skuIds || [] });
        listRef.current?.setSelectedRowKeys(spuData.skuIds || [])
      } else {
        setState({ selectedRowKeys: SPUData.chooseSku?.map(item => item.id) || [] , selectedRows: SPUData.chooseSku });
        listRef.current?.setSelectedRowKeys(SPUData.chooseSku?.map(item => item.id) || [])
      }
    }
  }, [open, spuData]);

  const fetchList = ({ query }) => {
    const productId = changeDataSource ? spuData.productId : props.productId
    if (!productId) return Promise.reject()
    return new Promise((resolve, reject) => {
      getProductSkuSelectList({
        productId: productId,
        queryShops: true,
        ...query,
      }).then(res => {
        resolve({ records: res })
      }).catch(err => {
        reject(err)
      })
    })
  }

  const onFinish = () => {
    if (state.selectedRowKeys.length <= 0) {
      message.error('请选择至少一条SKU');
      return;
    }
    setSPUData((SPUData) => {
        return changeDataSource ? {
          ...SPUData,
          dataSource: SPUData.dataSource.map(item => {
            if (item.id === spuData.id) {
              return {
                ...item,
                skuIds: state.selectedRowKeys
              }
            }
            return item
          }),
        } : {...SPUData, chooseSku: state.selectedRows,}
      }
    )
    onClose();
  }

  const extension = {
    request: { fetchList },
    rowKey: 'id',
    rowSelection: {
      preserveSelectedRowKeys: true,
      selectedRowKeys: state.selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        setState({ selectedRowKeys, selectedRows })
      },
    },
    customRender: {
      nameRender(v) {
        return <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      enabledRender(v) {
        return <STags
          itemKey=""
          label={v ? '启用' : '禁用'}
          fontColor={v ? '#00A865' : '#EB3723'}
          bgColor={v ? '#D7F7EA' : '#FFEAE8'}
        />
      },
      argMapRender(v){
        const data = v ? Object.values(v) : []
        return data.map(item => `${item.argName}: ${item.valueName}`).join(', ')
      }
    }
  }

  return <>
    <SDrawerOrModal
      title={'SKU选择'}
      width={900}
      open={open}
      loading={false}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
  </>
}

export default ChooseSKUModal